///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/memberships.collection.ts"/>
///<reference path="../collections/membership-types.collection.ts"/>
///<reference path="../collection-population-strategies/membership-to-membership-type.strategy.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class MembershipsWithTypesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected memberships: MembershipsCollection;
        protected membershipTypes: MembershipTypesCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.membershipTypes;
        }

        get totalSelectedCount(): number {
            return this.memberships.value.length;
        }

        get leafCollection() {
            return this.memberships;
        }

        reconnectLeafCollectionModel(model) {
            this.leafCollection.connectedModel = model[this.properties[1]];
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.membershipTypes = new MembershipTypesCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                smartMoverHidden: () => this.smartMoverHidden,
            });

            this.memberships = new MembershipsCollection(this.model[properties[1]], [], {
                criteria: {
                    includeInactive: true,
                    ...options.criteria,
                },
                smartMoverHidden: () => this.smartMoverHidden,
            });

            this.memberships.setParentCollection(this.membershipTypes, MembershipToMembershipType);

            this.filters = [
                new ActiveInactiveFilter({hideInactiveLabel: 'LABEL_HIDE_INACTIVE'}, this)
            ];
            this.memberships.addFilters(...this.filters as IInteractiveFilter[]);

            this.title = 'LABEL_MEMBERSHIPS';
            this.allSelectedLabel = 'LABEL_ALL_MEMBERSHIPS';
            this.totalSelectedMessage = 'LABEL_TOTAL_MEMBERSHIPS_SELECTED';
        }

        setWatchers(scope: angular.IScope) {
            this.memberships.setWatchers(scope);

            super.setWatchers(scope);
        }
    }
}
